/**
 * Cookie storage partagé entre artkiv.com et vision.artkiv.com.
 * Le cookie est posé sur domain=.artkiv.com — accessible aux deux apps.
 */
const COOKIE_DOMAIN = ".artkiv.com";
const MAX_AGE = 60 * 60 * 24 * 365; // 1 an

export const cookieStorage = {
  getItem: (key) => {
    const match = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${encodeURIComponent(key)}=`));
    if (!match) return null;
    try {
      return decodeURIComponent(match.split("=").slice(1).join("="));
    } catch {
      return null;
    }
  },

  setItem: (key, value) => {
    document.cookie = [
      `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
      `domain=${COOKIE_DOMAIN}`,
      "path=/",
      `max-age=${MAX_AGE}`,
      "SameSite=Lax",
      "Secure",
    ].join("; ");
  },

  removeItem: (key) => {
    document.cookie = [
      `${encodeURIComponent(key)}=`,
      `domain=${COOKIE_DOMAIN}`,
      "path=/",
      "max-age=0",
      "SameSite=Lax",
      "Secure",
    ].join("; ");
  },
};
